import { useCurrentClient } from '@pbk-web/state';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { FormTemplatePagedFilter } from '../models/Form';
import ClientTemplateFormService from '../services/ClientTemplateFormService';

const useFetchClientTemplateForms = (filter: FormTemplatePagedFilter, disabled: boolean) => {
  const currentClient = useCurrentClient((x) => x.value);

  const service = useMemo(() => currentClient && new ClientTemplateFormService(currentClient.id), [currentClient]);

  return useInfiniteQuery({
    queryKey: ['client-template-forms', currentClient?.id, filter],
    staleTime: 5 * 60 * 1000, // 5 minutes
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => {
      return service!.getAllTemplatesPaged({ ...filter, latestOnly: true, pageNumber: pageParam });
    },
    getNextPageParam(lastPage) {
      return lastPage.hasNextPage ? (lastPage.pageNumber ?? 0) + 1 : undefined;
    },
    enabled: !!currentClient && !disabled,
  });
};

export default useFetchClientTemplateForms;
